import React from 'react';

const COLORS = ['#2ec4a5', '#4a90d9', '#f5a623', '#e85d75', '#9b59b6', '#50c7b0', '#e05e5e', '#3ec97f'];

// The LTL carrier-type bucket is hidden by default; it is only shown once the user has explicitly
// selected the LTL shipment type, where suppressing it would leave the card empty.
export default function CarrierCbmChart({ data, includeLtl }) {
	const filtered = includeLtl ? data : data.filter(d => d.carrierType.toUpperCase() !== 'LTL');
	if (!filtered.length) return null;

	const maxCbm = Math.max(...filtered.map(d => parseFloat(d.cbm)), 1);

	return (
		<div className="carrier-cbm-card">
			<div className="carrier-cbm-card__header">
				<span className="carrier-cbm-card__title">Carrier CBM</span>
			</div>
			<div className="carrier-cbm-card__rows">
				{filtered.map((d, i) => {
					const cbm = parseFloat(d.cbm);
					const pct = (cbm / maxCbm) * 100;
					return (
						<div key={d.carrierType} className="carrier-cbm-row">
							<div className="carrier-cbm-row__label">{d.carrierType}</div>
							<div className="carrier-cbm-row__track">
								<div
									className="carrier-cbm-row__bar"
									style={{ width: `${pct}%`, background: COLORS[i % COLORS.length] }}
								/>
							</div>
							<div className="carrier-cbm-row__value">{cbm.toFixed(1)}</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
